import { FullPageSpinner } from '@/components/loading_states/generic-spinner'
import { useAuth } from '@/components/providers/auth-provider'
import { Button } from '@/components/ui/button'
import {
  Form,
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from '@/components/ui/form'
import { Input } from '@/components/ui/input'
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select'
import { sleep } from '@/lib/utils/generic-utils'
import { useTRPC } from '@/trpc/react'
import { arktypeResolver } from '@hookform/resolvers/arktype'
import { APP_NAME } from '@repo/shared_utils/constants'
import { employeeRegFormSchema, type EmployeeRegFormSchema } from '@repo/trpc/form-validation'
import { useMutation } from '@tanstack/react-query'
import { createFileRoute, useNavigate } from '@tanstack/react-router'
import { useForm } from 'react-hook-form'
import { toast } from 'sonner'

export const Route = createFileRoute('/onboarding')({
  component: RouteComponent,
  // beforeLoad: async ({ context }) => {
  //   console.log('context', context)
  //   if (!context.auth || !context.auth.isAuthenticated) {
  //     // if (!context.auth.isAuthenticated) {
  //     throw redirect({ to: '/login' })
  //   }
  //   if (context.auth.isUserOnboarded) {
  //     throw redirect({ to: '/dashboard' })
  //   }
  // },
})

function RouteComponent() {
  const api = useTRPC()
  const createEmployee = useMutation({
    ...api.employee.createEmployee.mutationOptions(),
    onSuccess: async (data) => {
      console.log('data', data)
      toast.success('Employee created successfully', {
        description: `Redirecting you to the dashboard portal...`,
      })
      await sleep(1000)
      navigate({ to: '/dashboard' })
      await sleep(100)
      window.location.reload()
    },
    onError: (error) => {
      console.error('error', error)
      toast.error('Failed to create employee', {
        description: error.message,
      })
    },
  })
  const navigate = useNavigate()

  const { isAuthenticated, isPending, isUserOnboarded, user } = useAuth()
  const employeeRegForm = useForm<EmployeeRegFormSchema>({
    resolver: arktypeResolver(employeeRegFormSchema),
    // defaultValues: {
    //   "birthDate": new Date()
    // },
  })

  function onSubmit(values: EmployeeRegFormSchema) {
    console.log('values', values)
    createEmployee.mutate(values)
    // try {
    //   console.log(values)
    //   toast(
    //     <pre className="mt-2 w-[340px] rounded-md bg-slate-950 p-4">
    //       <code className="text-white">{JSON.stringify(values, null, 2)}</code>
    //     </pre>,
    //   )
    // } catch (error) {
    //   console.error('Form submission error', error)
    //   toast.error('Failed to submit the form. Please try again.')
    // }
  }

  if (isPending) return <FullPageSpinner />
  // console.log({ isAuthenticated, isPending, isUserOnboarded })

  // console.log({ isAuthenticated, isPending, isUserOnboarded })
  // console.log(!isAuthenticated && !isPending)
  console.log({ isAuthenticated, isUserOnboarded })
  if (!isAuthenticated && !isPending) navigate({ to: '/login' })

  if (isUserOnboarded && !isPending) navigate({ to: '/dashboard' })

  return (
    <>
      <div className="max-w-xl mx-auto py-8">
        <h1 className="text-3xl font-bold tracking-tight text-primary mb-2">
          Welcome to {APP_NAME}
        </h1>
        <p className="text-muted-foreground text-base mb-4">
          Let's get you set up! Please fill out your employee details below to complete your
          onboarding process.
        </p>
      </div>
      <Form {...employeeRegForm}>
        <form
          onSubmit={employeeRegForm.handleSubmit(onSubmit)}
          className="space-y-2 max-w-xl mx-auto py-2"
        >
          <FormField
            control={employeeRegForm.control}
            name="businessId"
            render={({ field }) => (
              <FormItem>
                <FormLabel>Business Id</FormLabel>
                <FormControl>
                  <Input placeholder="" type="text" {...field} />
                </FormControl>

                <FormMessage />
              </FormItem>
            )}
          />

          <FormField
            // control={employeeRegForm.control}
            name="email"
            render={() => (
              <FormItem>
                <FormLabel>Email</FormLabel>
                <FormControl>
                  <Input value={user?.email ?? ''} disabled placeholder="email" type="email" />
                </FormControl>

                <FormMessage />
              </FormItem>
            )}
          />

          <FormField
            control={employeeRegForm.control}
            name="firstName"
            render={({ field }) => (
              <FormItem>
                <FormLabel>First Name</FormLabel>
                <FormControl>
                  <Input placeholder="" type="text" {...field} />
                </FormControl>

                <FormMessage />
              </FormItem>
            )}
          />

          <FormField
            control={employeeRegForm.control}
            name="middleName"
            render={({ field }) => (
              <FormItem>
                <FormLabel>Middle Name</FormLabel>
                <FormControl>
                  <Input placeholder="" type="text" {...field} />
                </FormControl>

                <FormMessage />
              </FormItem>
            )}
          />

          <FormField
            control={employeeRegForm.control}
            name="lastName"
            render={({ field }) => (
              <FormItem>
                <FormLabel>Last Name</FormLabel>
                <FormControl>
                  <Input placeholder="" type="text" {...field} />
                </FormControl>

                <FormMessage />
              </FormItem>
            )}
          />

          <FormField
            control={employeeRegForm.control}
            name="phoneNumber"
            render={({ field }) => (
              <FormItem>
                <FormLabel>Phone Number</FormLabel>
                <FormControl>
                  <Input placeholder="" type="tel" {...field} />
                </FormControl>

                <FormMessage />
              </FormItem>
            )}
          />

          <FormField
            control={employeeRegForm.control}
            name="address"
            render={({ field }) => (
              <FormItem>
                <FormLabel>Address</FormLabel>
                <FormControl>
                  <Input placeholder="" type="text" {...field} />
                </FormControl>

                <FormMessage />
              </FormItem>
            )}
          />

          <div className="grid grid-cols-12 gap-4">
            <div className="col-span-4">
              <FormField
                control={employeeRegForm.control}
                name="gender"
                render={({ field }) => (
                  <FormItem>
                    <FormLabel>Gender</FormLabel>
                    <Select onValueChange={field.onChange} defaultValue={field.value}>
                      <FormControl>
                        <SelectTrigger>
                          <SelectValue placeholder="" />
                        </SelectTrigger>
                      </FormControl>
                      <SelectContent>
                        <SelectItem value="male">Male</SelectItem>
                        <SelectItem value="female">Female</SelectItem>
                        <SelectItem value="other">Other</SelectItem>
                      </SelectContent>
                    </Select>

                    <FormMessage />
                  </FormItem>
                )}
              />
            </div>
          </div>

          <div className="grid grid-cols-12 gap-4">
            <div className="col-span-4">
              <FormField
                control={employeeRegForm.control}
                name="birthDate"
                render={({ field }) => (
                  <FormItem className="flex flex-col">
                    <FormLabel>Date of birth</FormLabel>
                    {/* <Popover>
                      <PopoverTrigger asChild>
                        <FormControl>
                          <Button
                            variant={'outline'}
                            className={cn(
                              'w-[240px] pl-3 text-left font-normal',
                              !field.value && 'text-muted-foreground',
                            )}
                          >
                            {field.value ? (
                              DateTime.fromJSDate(field.value).toLocaleString(DateTime.DATE_MED)
                            ) : (
                              <span>Pick a date</span>
                            )}
                            <CalendarIcon className="ml-auto h-4 w-4 opacity-50" />
                          </Button>
                        </FormControl>
                      </PopoverTrigger>
                      <PopoverContent className="w-auto p-0" align="start"> */}
                    {/* <Calendar
                          mode="single"
                          // the selected prop for the Calendar component expects a Date (or Matcher), not a string.
                          selected={field.value ? new Date(field.value) : undefined}
                          onSelect={field.onChange}
                          initialFocus
                        /> */}
                    <Input
                      placeholder="Date of birth"
                      type="date"
                      value={field.value ? field.value.toISOString().split('T')[0] : ''}
                      // value={field.value}
                      onChange={(e) => {
                        field.onChange(new Date(e.target.value))
                      }}
                    />
                    {/* </PopoverContent>
                    </Popover> */}

                    <FormMessage />
                  </FormItem>
                )}
              />
            </div>
          </div>

          <FormField
            control={employeeRegForm.control}
            name="civilStatus"
            render={({ field }) => (
              <FormItem>
                <FormLabel>Civil Status</FormLabel>
                <FormControl>
                  <Input placeholder="" type="text" {...field} />
                </FormControl>

                <FormMessage />
              </FormItem>
            )}
          />

          <div className="grid grid-cols-12 gap-4">
            <div className="col-span-4">
              <FormField
                control={employeeRegForm.control}
                name="nameOfSpouse"
                render={({ field }) => (
                  <FormItem>
                    <FormLabel>Name of Spouse (if married)</FormLabel>
                    <FormControl>
                      <Input placeholder="" type="text" {...field} />
                    </FormControl>

                    <FormMessage />
                  </FormItem>
                )}
              />
            </div>
          </div>
          <Button
            disabled={createEmployee.isPending || isPending || !isAuthenticated || isUserOnboarded}
            type="submit"
          >
            {createEmployee.isPending ? 'Creating...' : 'Submit'}
          </Button>
        </form>
      </Form>
    </>
  )
}
